import { Directive, Input, ElementRef, OnInit, Injector } from '@angular/core';
/**
 * Directive that hides somes fields if the provided rules are evaluated to `true`.
 * It is mainly used in `edit` and `view` screens generated by `UI Studio` tool.
 *
 * This class should not be modified.
 */
@Directive({
  selector: '[plmFieldPolicy]',
})
export class FieldPolicyDirective implements OnInit {
  @Input('plmFieldPolicy') policyConfig: string;

  service: any;

  constructor(private elementRef: ElementRef, private injector: Injector) { }

  ngOnInit() {
    let featureName, useCaseName, fieldName;
    [featureName, useCaseName, fieldName] = this.policyConfig.split(',');
    try {
      if (featureName && useCaseName && fieldName) {
        this.service = this.injector.get(`${featureName}PolicyService`);
        if (this.service.isFieldRestricted(useCaseName, fieldName)) {
          this.hideElement();
        }
      }
    } catch (error) {
      // no policy service is provided for this feature
    }
  }

  /**
   * hide element when user is not allowed
   */
  hideElement() {
    this.elementRef.nativeElement.remove();
  }
}
